// Editing an existing pick is not an attempt to add another pick. Keep its
// exact line/variant and verification state; checkout validates the new side.
export const editLineupDirection = (selected, matches, side) => {
  if (!['more', 'less'].includes(side)) return selected;
  return selected.map((pick) => {
    if (!matches(pick) || pick._selectionSyncStatus === 'removed') return pick;
    if (side === 'less' && (pick.easy || pick.hard || pick.promo)) return pick;
    return pick.selected === side ? pick : { ...pick, selected: side };
  });
};
